/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryReindexEndpointRequest
 */
export interface TapeLibraryReindexEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryReindexEndpointRequest
     */
    barcode: string;
}

export function TapeLibraryReindexEndpointRequestFromJSON(json: any): TapeLibraryReindexEndpointRequest {
    return TapeLibraryReindexEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryReindexEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryReindexEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TapeLibraryReindexEndpointRequestToJSON(value?: TapeLibraryReindexEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
    };
}


